import React, { useState, useEffect, useCallback } from "react";
import UserSidbar from "../Layout/UserSidbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getUserRechargeHistory } from "../../redux/action/UserApi";
import Loader from "../Pages/Loader";

const Wallet = ({ isAuthenticated = false, user }) => {
  const [page, setPage] = useState(1);

  const {  totalPages, userPaymentHistory, message, error, loading } = useSelector(
    state => state.user
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const walletDetails = useCallback(() => {
    const postdata = {
      userId: localStorage.getItem("userId"),
      hash_token: localStorage.getItem("hashToken"),
      page: page,
      limit: 10,
    };

    dispatch(getUserRechargeHistory(postdata));
  }, [dispatch, page]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    } else {
      walletDetails();
    }

    if (error) {
      toast.error(error);
      dispatch({ type: "clearError" });
    }

    if (message) {
      toast.success(message);
      dispatch({ type: "clearMessage" });
    }
  }, [navigate, dispatch, walletDetails, isAuthenticated, error, message]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  return (
    <>
      {loading ? <Loader /> : ""}

      <section className="wallet_page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <UserSidbar user={user} />
            </div>
            <div className="col-lg-9 col-md-9 col-sm-6 col-xs-12">
              <div className="wallet_right">
                <div className="row charts_sec">
                  <div className="col-md-12 recharge_his">
                    <h5 className="">
                      Recharge History <img src="./assets/images/recharge.svg" alt="" />
                    </h5>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="recharge_history">
                      <div className="table_header">
                          <span>Date</span>
                          <span>Credit Amout</span>
                          <span>GST</span>
                          <span>Balance Amount</span>
                      </div>

                      {userPaymentHistory && userPaymentHistory.length > 0 ? (
                        userPaymentHistory.map((paylist, index) => (
                          <React.Fragment key={index}>
                            <div className={index % 2 ? "recharge_box" : "recharge_box or_c"}>
                              <div className="rec_date">
                                <span className="grey-cir"></span>
                                <span>{paylist.date}</span>
                              </div>
                              <p className="rs">₹{paylist.credit}</p>
                              <p className="gst">GST (18%) Rs. {paylist.gst}</p>
                              <span>₹{paylist.balance}</span>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <h1 className="mt-4">Not Found</h1>
                      )}

                      <div className="recharge_all">
                        {totalPages > 1 && (
                          <div className="pagination-wrapper text-center mt-4">
                            <button
                              className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                              disabled={page === 1}
                            >
                              &laquo; Prev
                            </button>

                            <span className="pagination-page">Page {page} of {totalPages}</span>

                            <button
                              className={`pagination-btn ${page === totalPages ? "disabled" : ""}`}
                              onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                              disabled={page === totalPages}
                            >
                              Next &raquo;
                            </button>
                          </div>
                        )}
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Wallet;
